import React from 'react'

import classes from './Cooperation.module.scss'

export const CooperationId = 'cooperation-block'

export const Cooperation = (): JSX.Element => {
  const cn = `col-xs-12 col-sm-4 ${classes.item}`
  return (
    <div
      className={`${classes.container} container reveal-from-bottom-medium`}
      data-reveal-delay={30}
      id={CooperationId}
    >
      <div className="row">
        <div className="col-xs-12">
          <h2 className={`${classes.title} second-title weight-bold uppercase`}>
            Преимущества <br /> KION:
          </h2>
        </div>
        <div className={cn}>
          <p className={`${classes.text} mb-1`}>
            Профессиональная команда с огромным опытом в индустрии
          </p>
        </div>
        <div className={cn}>
          <p className={`${classes.text} mb-1`}>
            Открытость и готовность к жанровым экспериментам
          </p>
        </div>
        <div className={cn}>
          <p className={`${classes.text} mb-1`}>
            Ресурсы экосистемы МТС для продвижения контента
          </p>
        </div>
      </div>
    </div>
  )
}
